import * as Sentry from "@sentry/react";

// Initialize Sentry with baseline configuration
Sentry.init({
  dsn: "https://fc3fc5cb20686f72b3fe7cab973b331f@o4509867058135040.ingest.us.sentry.io/4509867061739520",
  
  // Enable performance monitoring
  tracesSampleRate: 1.0,
  
  // Enable session replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  
  // Enable logs
  enableLogs: true,
  
  // Integrations
  integrations: [
    // Send console.log, console.warn, and console.error calls as logs to Sentry
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  
  // Environment configuration
  environment: process.env.NODE_ENV || "development",
  
  // Performance monitoring
  performance: true,
  
  // Error sampling
  sampleRate: 1.0,
});

export default Sentry;
